
import Vue, { PropType } from 'vue';
import PrideFlagSmall from '~/assets/img/PrideFlagSmall.jpg';

export type AttributeIconType = 'job' | 'flex' | 'relo' | 'lgb' | 'eth' | 'pwd';

export interface AttributeIconConfig {
    icon: string;
    title: string;
    activeBackground: string;
    backgroundIsImage?: boolean;
}
const attributeIconConfigs: Record<AttributeIconType, AttributeIconConfig> = {
    job: {
        icon: 'magnifying-glass',
        title: 'job',
        activeBackground: '#70c369',
    },
    flex: {
        icon: 'house-laptop',
        title: 'flex',
        activeBackground: '#df83ff',
    },
    relo: {
        icon: 'person-walking',
        title: 'relo',
        activeBackground: '#f5c076',
    },
    lgb: {
        icon: 'rainbow',
        title: 'lgbt+',
        activeBackground: `url('${PrideFlagSmall}')`,
        backgroundIsImage: true,
    },
    eth: {
        icon: 'star-of-life',
        title: 'eth',
        activeBackground: '#a19fff',
    },
    pwd: {
        icon: 'wheelchair',
        title: 'pwd',
        activeBackground: '#ff98a0',
    },
};

export default Vue.extend({
    name: 'AttributeIcon',
    props: {
        type: {
            type: String as PropType<AttributeIconType>,
            required: true,
        },
        active: {
            type: Boolean,
            required: true,
        },
        nonClickable: Boolean,
        noTooltip: Boolean,
    },
    computed: {
        config(): AttributeIconConfig {
            return attributeIconConfigs[this.type];
        },
    },
});
